import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getConsultations } from "../../api/consultation";
import "../../styles/AdminPanel/ConsultationList.css";

const SOURCE_TABS = [
  { key: "", label: "همه" },
  { key: "home", label: "فرم مشاوره" },
  { key: "contact", label: "فرم تماس" },
];

export default function ConsultationList() {
  const [items, setItems] = useState([]);
  const [source, setSource] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();

  const role = localStorage.getItem("role");
  const basePath =
    role === "admin" ? "/admin/support/consultation" : "/support/consultation";

  const PAGE_SIZE = 20;
  const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));
  const pageSafe = Math.min(page, totalPages);

  const pageNumbers = [];
  for (let n = 1; n <= totalPages; n++) pageNumbers.push(n);

  useEffect(() => {
    setLoading(true);
    const params = { page, ...(source ? { source } : {}) };
    getConsultations(params)
      .then((r) => {
        // پاسخ paginated: { count, results }
        const data = r.data;
        setTotalCount(data.count ?? 0);
        setItems(data.results ?? data);
      })
      .finally(() => setLoading(false));
  }, [source, page]);

  // وقتی تب عوض میشه، برگرد صفحه ۱
  function handleSourceChange(key) {
    setSource(key);
    setPage(1);
  }

  const Pagination = () =>
    totalCount > 0 && (
      <div className="orders-pagination">
        <span className="pagination-info">
          {totalCount.toLocaleString("fa-IR")} مورد — صفحه{" "}
          {pageSafe.toLocaleString("fa-IR")} از{" "}
          {totalPages.toLocaleString("fa-IR")}
        </span>
        <div className="pagination-controls">
          <button
            className="page-btn"
            disabled={pageSafe === 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            aria-label="صفحه قبل"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M15 6l-6 6 6 6" />
            </svg>
          </button>
          {pageNumbers.map((n) => (
            <button
              key={n}
              className={`page-btn number${n === pageSafe ? " active" : ""}`}
              onClick={() => setPage(n)}
            >
              {n.toLocaleString("fa-IR")}
            </button>
          ))}
          <button
            className="page-btn"
            disabled={pageSafe === totalPages}
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            aria-label="صفحه بعد"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 6l6 6-6 6" />
            </svg>
          </button>
        </div>
      </div>
    );

  return (
    <div className="consultation-list">
      <div className="cl-header">
        <h2>فرم‌های مشاوره و تماس</h2>

        <div className="cl-tabs">
          {SOURCE_TABS.map((tab) => (
            <button
              key={tab.key}
              className={`cl-tab ${source === tab.key ? "active" : ""}`}
              onClick={() => handleSourceChange(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <p className="cl-loading">در حال بارگذاری...</p>
      ) : items.length === 0 ? (
        <p className="cl-empty">موردی یافت نشد.</p>
      ) : (
        <>
          <table className="cl-table">
            <thead>
              <tr>
                <th>#</th>
                <th>نام</th>
                <th>موبایل</th>
                <th>نوع فرم</th>
                <th>موضوع / کسب‌وکار</th>
                <th>تاریخ ثبت</th>
                <th>کامنت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id}>
                  <td data-label="#">{item.id}</td>
                  <td data-label="نام">{item.full_name}</td>
                  <td data-label="موبایل" dir="ltr">
                    {item.mobile}
                  </td>
                  <td data-label="نوع فرم">{item.source_display}</td>
                  <td data-label="موضوع / کسب‌وکار">
                    {item.source === "home"
                      ? item.business_type || "—"
                      : item.subject || "—"}
                  </td>
                  <td data-label="تاریخ ثبت">
                    {new Date(item.created_at).toLocaleString("fa-IR")}
                  </td>
                  <td data-label="کامنت">{item.comment_count}</td>
                  <td data-label="عملیات">
                    <button
                      className="cl-btn-detail"
                      title="جزئیات"
                      aria-label="جزئیات"
                      onClick={() => navigate(`${item.id}`)}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="details-btn-icon"
                      >
                        <path d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination />
        </>
      )}
    </div>
  );
}
